import { createReducer } from 'redux-orm';

import orm from '../models/orm';

export default createReducer(orm);
